import { CalendarWithAvailability } from '../CalendarWithAvailability';
import { useReservationCalendar } from './reservation-calendar.hooks';

export const ReservationCalendar = ({ serviceIds }: { serviceIds: string | undefined }) => {
  const {
    date,
    currentMonth,
    highlightedDays,
    isLoading,
    handleMonthChange,
    handleCalendarChange,
  } = useReservationCalendar(serviceIds);

  if (!serviceIds) {
    return null;
  }

  return (
    <CalendarWithAvailability
      value={date}
      referenceDate={currentMonth.toDate()}
      isLoading={isLoading}
      highlightedDays={highlightedDays}
      onMonthChange={handleMonthChange}
      onChange={handleCalendarChange}
    />
  );
};
